import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

/**
 * Long-form product content (images, embedded videos, formatted text)
 * authored by the admin via the rich text editor. Rendered below the
 * main product card, full width.
 */
const ProductDetailsContent = ({ html }) => {
  const clean = useMemo(() => {
    if (!html || !html.trim()) return '';
    // Quill's video embed renders an <iframe>; allow it through, everything
    // else (scripts, event handlers, etc.) is still stripped by DOMPurify.
    return DOMPurify.sanitize(html, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target'],
    });
  }, [html]);

  if (!clean) return null;

  return (
    <section className="mt-12 border-t border-gray-100 pt-10">
      <div
        className="prose prose-sm sm:prose-base mx-auto max-w-2xl text-center break-words [&_*]:max-w-full [&_iframe]:aspect-video [&_iframe]:w-full [&_iframe]:rounded-lg [&_img]:mx-auto [&_img]:rounded-lg"
        dangerouslySetInnerHTML={{ __html: clean }}
      />
    </section>
  );
};

export default ProductDetailsContent;
